import { render, staticRenderFns } from "./CbsConstructorStepCard.vue?vue&type=template&id=2a0f841c&scoped=true"
import script from "./CbsConstructorStepCard.vue?vue&type=script&lang=js"
export * from "./CbsConstructorStepCard.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructorStepCard.vue?vue&type=style&index=0&id=2a0f841c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f841c",
  null
  
)

export default component.exports